(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7620],{

/***/ 35779:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-commitment",
      function () {
        return __webpack_require__(36592);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ OurCommitmentFeature; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 287 modules
var shared_src = __webpack_require__(40405);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 118 modules
var ui_src = __webpack_require__(32014);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/landing/feature-our-commitment/src/lib/components/intro/intro.module.css
var intro_module = __webpack_require__(65698);
var intro_module_default = /*#__PURE__*/__webpack_require__.n(intro_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-our-commitment/src/lib/components/intro/intro.tsx





const Intro = (blok)=>{
    const { title , body , image  } = blok;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ...(0,src/* storyblokEditable */.LF)(blok),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontSize: "xxl",
                fontWeight: "bold",
                element: "h2",
                lineHeight: "display",
                className: (intro_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ContentSection */.IH, {
                children: (0,shared_src/* renderWithResolver */.be)(body)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (intro_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (0,src/* getStoryblokImageServiceUrl */.Vb)(image.filename, {
                        width: 900,
                        filters: [
                            {
                                quality: 50
                            }
                        ]
                    }),
                    className: (intro_module_default()).image,
                    alt: image.alt ?? undefined
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/landing/feature-our-commitment/src/lib/components/content-with-icon/content-with-icon.module.css
var content_with_icon_module = __webpack_require__(13003);
var content_with_icon_module_default = /*#__PURE__*/__webpack_require__.n(content_with_icon_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-our-commitment/src/lib/components/content-with-icon/content-with-icon.tsx





const ContentWithIcon = (blok)=>{
    const { contentWithIcon  } = blok;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        ...(0,src/* storyblokEditable */.LF)(blok),
        className: (content_with_icon_module_default()).container,
        "data-testid": "content-with-icon",
        children: contentWithIcon.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ContentSectionWithIcon */.$n, {
                iconName: item.iconName,
                iconGradient: "galaxy",
                title: item.title,
                children: (0,shared_src/* renderWithResolver */.be)(item.body)
            }, item.title))
    });
};

// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
// EXTERNAL MODULE: ../../../libs/landing/feature-our-commitment/src/lib/components/help-me-choose/help-me-choose.module.css
var help_me_choose_module = __webpack_require__(89053);
var help_me_choose_module_default = /*#__PURE__*/__webpack_require__.n(help_me_choose_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-our-commitment/src/lib/components/help-me-choose/help-me-choose.tsx






const HelpMeChoose = (blok)=>{
    const { title , body , buttonLabel  } = blok;
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ...(0,src/* storyblokEditable */.LF)(blok),
        className: (help_me_choose_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ContentSection */.IH, {
                title: title,
                classNames: {
                    title: (help_me_choose_module_default()).title
                },
                sectionWrapperClass: (help_me_choose_module_default()).contentSectionWrapper,
                children: (0,shared_src/* renderWithResolver */.be)(body)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Secondary */.T7, {
                classNames: {
                    button: (help_me_choose_module_default()).button
                },
                element: "a",
                href: "/help-me-choose/most-important",
                onClick: ()=>{
                    trackEvent({
                        eventName: `Our commitment - ${buttonLabel}`,
                        data: {
                            event: {
                                name: analytics_src/* EventActions.click */.DI.click,
                                category: analytics_src/* EventCategories.button */.ro.button,
                                label: buttonLabel
                            }
                        },
                        type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE
                    });
                },
                children: buttonLabel
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../node_modules/next/router.js
var next_router = __webpack_require__(35837);
// EXTERNAL MODULE: ../../../libs/landing/feature-our-commitment/src/lib/components/prefooter/prefooter.module.css
var prefooter_module = __webpack_require__(19735);
var prefooter_module_default = /*#__PURE__*/__webpack_require__.n(prefooter_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-our-commitment/src/lib/components/prefooter/prefooter.tsx





const Prefooter = (blok)=>{
    const { title , subtitle , iconName , buttonLabel  } = blok;
    const router = (0,next_router.useRouter)();
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const handleClick = ()=>{
        trackEvent({
            eventName: `Our commitment - ${buttonLabel}`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: analytics_src/* EventCategories.button */.ro.button,
                    label: buttonLabel
                }
            }
        });
        router.push("/used-cars");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FullWidthCTA */.S3, {
        iconName: iconName,
        iconGradient: "galaxy",
        iconSize: 41,
        title: title,
        subtitle: subtitle,
        buttonLabel: buttonLabel,
        onButtonClick: handleClick,
        className: (prefooter_module_default()).container
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-our-commitment/src/lib/components/index.ts





;// CONCATENATED MODULE: ../../../libs/landing/feature-our-commitment/src/lib/data/storyblok-renderer-map.ts


const storyblokComponents = {
    GenericContentWithImageSection: Intro,
    ContentWithIconSection: ContentWithIcon,
    HelpMeChooseCTASection: HelpMeChoose,
    PrefooterCTA: Prefooter,
    StatsSection: shared_src/* StatsSection */.No
};

// EXTERNAL MODULE: ../../../libs/landing/feature-our-commitment/src/lib/our-commitment.module.css
var our_commitment_module = __webpack_require__(13046);
var our_commitment_module_default = /*#__PURE__*/__webpack_require__.n(our_commitment_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-our-commitment/src/lib/our-commitment.tsx






function OurCommitmentFeature({ story , generatedAt , preview  }) {
    const typedStory = story;
    const { content  } = (0,src/* useStoryblokState */.f0)({
        story: typedStory,
        enableBridge: preview
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                generatedAt: generatedAt,
                fallbackTitle: "Our commitment - cinch",
                fallbackDescription: "We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: (our_commitment_module_default()).root,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                            block: content.introSection,
                            components: storyblokComponents
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                            block: content.contentWithIconsSection,
                            components: storyblokComponents
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        isFluid: true,
                        backgroundColor: "#ECF5FA",
                        className: {
                            container: (our_commitment_module_default()).statsSectionContainer
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                            block: content.statsSection,
                            components: storyblokComponents,
                            props: {
                                trackingEventName: "Our commitment - Browse all car clicks"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                            block: content.helpMeChooseSection,
                            components: storyblokComponents
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                        block: content.preFooterCTASection,
                        components: storyblokComponents
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/landing/feature-our-commitment/src/lib/get-static-props.ts


async function getStaticPropsfn({ preview =false  }) {
    try {
        var ref, ref1;
        const story = await (0,src/* getStoryBySlug */.OI)("our-commitment", {
            version: preview ? "draft" : "published"
        });
        if (!story) {
            throw new Error("Unable to fetch `our-commitment` story from storyblok");
        }
        const heroProps = (ref = story.content) === null || ref === void 0 ? void 0 : (ref1 = ref.hero) === null || ref1 === void 0 ? void 0 : ref1[0];
        (0,datadog_server_src/* setTag */.YA)("response.code", 200);
        (0,datadog_server_src/* setTag */.YA)("page.name", "our-commitment");
        (0,datadog_server_src/* setTag */.YA)("page.rendered", "ISR");
        (0,datadog_server_src/* setTag */.YA)("page.params", JSON.stringify({
            preview
        }, null, 2));
        return {
            props: {
                story,
                preview,
                generatedAt: Date.now(),
                layoutProps: {
                    heroProps,
                    showBorderRadius: true
                }
            },
            revalidate: 300
        };
    } catch (error) {
        if (typeof error === "string" || error instanceof Error) {
            (0,datadog_server_src/* tagError */.$k)(error);
        }
        (0,datadog_server_src/* setTag */.YA)("page.response-code", "404");
        console.log(error);
        return {
            notFound: true,
            props: {
                story: null,
                preview,
                generatedAt: Date.now(),
                layoutProps: {
                    heroProps: [],
                    showBorderRadius: true
                }
            },
            revalidate: 300
        };
    }
}
const getStaticProps = (0,datadog_server_src/* traceFunction */.KG)("our-commitment.getStaticProps", getStaticPropsfn);

;// CONCATENATED MODULE: ../../../libs/landing/feature-our-commitment/src/index.ts



;// CONCATENATED MODULE: ./pages/our-commitment.tsx
var __N_SSG = true;



/***/ }),

/***/ 13003:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"content-with-icon_container__gsHhY"};

/***/ }),

/***/ 89053:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"help-me-choose_container___YvRL","contentSectionWrapper":"help-me-choose_contentSectionWrapper__J533d","title":"help-me-choose_title__2o4Ou","button":"help-me-choose_button__4oNz_"};

/***/ }),

/***/ 65698:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"intro_title__zm_Nm","imageContainer":"intro_imageContainer__S73pY","image":"intro_image___sPmg"};

/***/ }),

/***/ 19735:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"prefooter_container__sir3t"};

/***/ }),

/***/ 13046:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"our-commitment_root__0g5Nv","statsSectionContainer":"our-commitment_statsSectionContainer__VQ2T_"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(35779); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);